import controller from './wf-affect-list.controller';
import template from './wf-affect-list.html';
import './wf-affect-list.scss';

export default {
	controller,
	template,
	bindings: {
		data:         '<?ngModel',
		disabled:     '<ngDisabled',
		form:         '<',
		kid:          '<',
		modelActions: '=',
	},
	require: {
		kform: '^^?kform',
	},
};
